import {Primitive} from 'ts-essentials';
import type {Options} from './createTranslator';
import {ExtractMessageValues, ParsedMessage} from './parse';

export function compile<
  Message extends string,
  PlaceholderKey extends ExtractMessageValues<Message>,
>(
  parsedMessage: ParsedMessage<Message>,
  values: Record<PlaceholderKey[number], Primitive> | undefined,
  options: Options,
): string {
  let message = parsedMessage.rawMessage;

  if (!values) {
    return message;
  }

  Object.entries(values).forEach(([key, value]) => {
    message = message.replace(
      new RegExp(`${options.prefix}-?\\s?${key}\\s?${options.suffix}`, 'gm'),
      String(value),
    ) as Message;
  });

  return message;
}
